// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__36FvB","legacyBtn":"MutateMid_legacyBtn__3WG8R"};